import { render, staticRenderFns } from "./BulkHoursEditor.vue?vue&type=template&id=ffbdc47e&scoped=true&"
import script from "./BulkHoursEditor.vue?vue&type=script&lang=js&"
export * from "./BulkHoursEditor.vue?vue&type=script&lang=js&"
import style0 from "./BulkHoursEditor.vue?vue&type=style&index=0&id=ffbdc47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbdc47e",
  null
  
)

export default component.exports